import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TTextDM from './TTextDM'
import TDocumentShreddingPlanDM from './TDocumentShreddingPlanDM'
import TLanguageMemoTranslationDM from './TLanguageMemoTranslationDM'

export default class TExternalDocumentConfigurationDM extends Data {
	public static className = 'TExternalDocumentConfigurationDM'
	public static primaryKey = 'Id'
	public static systemFields = [
		'TimeStamp',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.Id!
	}

	TimeStamp?: string
	RightGroupId?: number
	TypeId?: number
	Description?: string
	Abbr?: string
	Id?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	SQLSequenceOrderCalc?: number
	PlainTextCalc?: string
	LanguageDescriptionCalc?: string
	TranslatedImgCalc?: string
	NoteCalc?: string
	TextCalc?: string
	Description100Calc?: string
	ContentTextCalc?: string
	ContentPlainTextCalc?: string
	TextFormatCalc?: number
	InputPathCalc?: string
	ArchiveFolderPathCalc?: string
	DefaultExtensionCalc?: string
	MaskCalc?: string
	RunCalc?: string
	ApplicationParameterCalc?: string
	OutputNameCalc?: string
	CopyFileKindSupplementCalc?: string
	DocumentTransferCalc?: string
	InputFolderCalc?: string
	ArchivePathCalc?: string
	DescriptionCalc?: string
	DocumentPathCalc?: string
	TagsCalc?: string
	IsVersioningOnCalc?: string
	DeleteFileAfterImportCalc?: string
	MaxFileSizeCalc?: number
	NameCalc?: string
	HiddenInMenuBitCalc?: number
	RightGroupIdCalc?: number
	@Type(() => TTextDM)
	LanguageAbbrCalc?: TTextDM
	@Type(() => TTextDM)
	TranslatedBitCalc?: TTextDM
	@Type(() => TTextDM)
	CopyFileKindIdCalc?: TTextDM
	@Type(() => TDocumentShreddingPlanDM)
	ShreddingPlanIdCalc?: TDocumentShreddingPlanDM
	@Type(() => TLanguageMemoTranslationDM)
	LanguageMemoChild?: TLanguageMemoTranslationDM[]
}